export const Base_Url = {
  base_url: process.env.REACT_APP_BASE_URL,
};
